<template>
  <v-layout>
    <filtersMaster ref="filtersMaster" :select="select" :filtersdef="filtros" :options="options" @filter="filter" @loadSelectsData="loadSelectsData" />
    <v-layout column right floating class="fab-container" style="z-index: 1">
      <v-btn color="primary" fab small dark :title="$t('view.commons.report')" :loading="view.action.submit.busy" class="btn_tippy_menu" @click="report">
        <v-icon small>fas fa-file-excel</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        users: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , vendor: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , rep: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        users: []
        , fecha: []
        , vendor: []
        , rep: []
        , enabled: []
      }
      , options: [
        {
          code: "users"
          , name: this.$t("view.reportes.reporteusuarios.filters.users")
          , icon: "fas fa-user-tie"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "fecha"
          , name: this.$t("view.reportes.reporteusuarios.filters.fecha")
          , icon: "fas fa-calendar-check"
          , type: "date"
          , selected: { ini: "", end: "" }
          , disabled: false
        }
        , {
          code: "vendor"
          , name: this.$t("view.reportes.reporteusuarios.filters.vendor")
          , icon: "fas fa-hand-holding-usd"
          , type: "select"
          , selected: {}
          , disabled: this.$store.getters.getUserData.tipoUsuario != "ADMINISTRADOR"
        }
        , {
          code: "rep"
          , name: this.$t("view.reportes.reporteusuarios.filters.rep")
          , icon: "fas fa-file-invoice-dollar"
          , type: "select"
          , selected: {}
          , disabled: false
        }
        , {
          code: "enabled"
          , name: this.$t("view.reportes.reporteusuarios.filters.enabled")
          , icon: "fas fa-check"
          , type: "sino"
          , selected: true
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {
      if (this.init) {
        this.loadSelectUsers();
        this.loadSelectVendor();
        this.loadSelectRep();
        if (this.select.users.filteredList.length > 0) this.init = false;
      }
    }
    , async loadSelectUsers() {
      const { data: { results: { combo: usersList } } } = await CombosAPI.get({ option: "usuarios" });
      this.select.users.filteredList = usersList || [];
      this.select.users.completeList = usersList || [];
    }
    , async loadSelectVendor() {
      const { data: { results: { combo: vendorList } } } = await CombosAPI.get({ option: "vendor" });
      this.select.vendor.filteredList = vendorList || [];
      this.select.vendor.completeList = vendorList || [];
    }
    , async loadSelectRep() {
      const tipoUsuario = this.$store.getters.getUserData.tipoUsuario;
      const idVendor = this.$store.getters.getUserData.idVendor;
      const { data: { results: { combo: repList } } } = tipoUsuario == "VENDOR" ? await CombosAPI.getByParameter({ option: "repsPorVendor", parameter: idVendor }) : await CombosAPI.get({ option: "rep" });
      this.select.rep.filteredList = repList || [];
      this.select.rep.completeList = repList || [];
    }
    , report() {
      this.$emit("report");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/reportes/reporteusuarios/Filters.vue